"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AGREE_COOKIES_BUTTON: function() {
        return AGREE_COOKIES_BUTTON;
    },
    LEARN_MORE_BUTTON: function() {
        return LEARN_MORE_BUTTON;
    },
    NOTICE_TITLE: function() {
        return NOTICE_TITLE;
    }
});
var NOTICE_TITLE = {
    ca: "Cookies per a la millor experiència en JobTeaser 🚀",
    cs: "Cookies pro lepší zážitek na JobTeaser 🚀",
    da: "Cookies for en bedre oplevelse på JobTeaser 🚀",
    de: "Cookies und andere Technologien",
    en: "Cookies for the best experience on JobTeaser 🚀",
    es: "Cookies para una mejor experiencia en JobTeaser 🚀",
    fi: "Evästeet parempaan käyttökokemukseen JobTeaser-sivustolla 🚀",
    fr: "Des cookies pour une meilleure expérience sur JobTeaser 🚀",
    gl: "Cookies para una mejor experiencia en JobTeaser 🚀",
    it: "Cookie per una migliore esperienza su JobTeaser 🚀",
    nl: "Cookies voor een betere ervaring op JobTeaser 🚀",
    no: "Informasjonskapsler for en bedre opplevelse på JobTeaser 🚀",
    pl: "Pliki cookie dla lepszych doświadczeń na JobTeaser 🚀",
    pt: "Cookies para uma melhor experiência en JobTeaser 🚀",
    sv: "Cookies för en bättre upplevelse på JobTeaser 🚀"
};
var LEARN_MORE_BUTTON = {
    ca: "Configuració",
    cs: "Nastavení",
    da: "Indstillinger",
    de: "Einstellungen",
    en: "Settings",
    es: "Ajustes",
    fi: "Asetukset",
    fr: "Paramètres",
    gl: "Ajustes",
    it: "Impostazioni",
    nl: "Instellingen",
    no: "Instellingen",
    pl: "Ustawienia",
    pt: "Definições",
    sv: "Inställningar"
};
var AGREE_COOKIES_BUTTON = {
    ca: "D'acord per a mi!",
    cs: "Pro mě v pořádku !",
    da: "Ok for mig !",
    de: "Alles akzeptieren",
    en: "Good for me !",
    es: "¡Bien por mí!",
    fi: "Okei minulle !",
    fr: "Ok pour moi !",
    gl: "¡Bien por mí!",
    it: "Per me va bene !",
    nl: "Ok voor mij !",
    no: "Ok for meg !",
    pl: "Ok dla mnie !",
    pt: "Para mim está bem !",
    sv: "Okej för mig !"
};

//# sourceMappingURL=translations.js.map